import { createFileRoute } from "@tanstack/react-router";
import SpravatoTiredOfMedication from "@/pages/SpravatoTiredOfMedication";
export const Route = createFileRoute("/spravato-tired-of-medication")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Spravato Tired Of Medication | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Tired of trying depression medications? SPRAVATO may help when antidepressants haven’t worked. Learn more in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Spravato Tired Of Medication | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Tired of trying depression medications? SPRAVATO may help when antidepressants haven’t worked. Learn more in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/spravato-tired-of-medication",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/spravato-tired-of-medication",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SpravatoTiredOfMedication />;
}
